import React, { useState } from 'react';
import PriceCard from '../../components/PriceCard';
import { Check } from 'lucide-react';
import { checkHasPaymentMethod } from '../../utils/api';
import ScrollToTop from '../../components/layout/ScrollToTop';

const Subscription = () => {
  const [isYearly, setIsYearly] = useState(false);
  
  const toggleBilling = () => {
    setIsYearly(!isYearly);
  };
  
  return (
    <div className="min-h-screen bg-gray-50">
      <ScrollToTop />
      
      {/* Pricing Header */}
      <section className="pt-16 pb-8 md:pt-24 md:pb-12">
        <div className="container-custom text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Simple, transparent pricing
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
            Choose the plan that's right for your business. All plans include unlimited leads viewing with different levels of engagement features.
          </p>
          
          {/* <div className="flex items-center justify-center mb-12">
            <span className={`mr-3 ${isYearly ? 'text-gray-500' : 'text-gray-900 font-medium'}`}>
              Monthly
            </span>
            <button
              onClick={toggleBilling}
              className="relative inline-flex h-6 w-11 items-center rounded-full bg-gray-200"
            >
              <span className="sr-only">Toggle billing frequency</span>
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${
                  isYearly ? 'translate-x-6' : 'translate-x-1'
                }`}
              />
            </button>
            <span className={`ml-3 ${isYearly ? 'text-gray-900 font-medium' : 'text-gray-500'}`}>
              Yearly <span className="text-green-600 font-medium">(-20%)</span>
            </span>
          </div> */}
        </div>
      </section>
      
      {/* Pricing Cards */}
      <section className="pb-20">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <PriceCard
              title="Starter"
              price={isYearly ? "$0" : "$0"}
              description="Perfect for small businesses just getting started with lead generation."
              features={[
                "Add your company to the directory",
                "Basic lead generation",
                "Up to 30 days of lead history",
                "2 team seats",
                "Email support",
              ]}
              buttonText="Start Free Trial"
            />
            
            <PriceCard
              title="Professional"
              price={isYearly ? "$79" : "$99"}
              description="Ideal for growing businesses with an active sales team."
              features={[
                "5x more impressions than Starter",
                "Advanced lead filtering",
                "Video calling feature",
                "Ability to schedule demo meetings",
                "Priority email support",
                "Up to 3 months of lead history",
                "5 team seats",
              ]}
              isPopular={true}
              buttonText="Start Free Trial"
            />
            
            <PriceCard
              title="Enterprise"
              price={isYearly ? "$159" : "$199"}
              description="For organizations with multiple teams and complex requirements."
              features={[
                "10x more impressions than Starter",
                "Premium lead filtering",
                "Video calling feature",
                "Ability to schedule demo meetings",
                "Dedicated account manager",
                "24/7 priority support",
                "Up to 12 months of lead history",
                "15 team seats",
              ]}
              buttonText="Contact Sales"
            />
          </div>
        </div>
      </section>
      
      {/* Features Comparison */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
            Compare Features
          </h2>
          
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="py-4 px-6 text-left text-gray-500 font-medium">Features</th>
                  <th className="py-4 px-6 text-center text-gray-900 font-bold">Starter</th>
                  <th className="py-4 px-6 text-center text-purple-600 font-bold">Professional</th>
                  <th className="py-4 px-6 text-center text-gray-900 font-bold">Enterprise</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 text-gray-600">Directory listing</td>
                  <td className="py-4 px-6 text-center">
                    <Check className="inline-block h-5 w-5 text-green-500" />
                  </td>
                  <td className="py-4 px-6 text-center">
                    <Check className="inline-block h-5 w-5 text-green-500" />
                  </td>
                  <td className="py-4 px-6 text-center">
                    <Check className="inline-block h-5 w-5 text-green-500" />
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 text-gray-600">Monthly lead views</td>
                  <td className="py-4 px-6 text-center text-gray-600">50</td>
                  <td className="py-4 px-6 text-center text-gray-600">200</td>
                  <td className="py-4 px-6 text-center text-gray-600">Unlimited</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 text-gray-600">Lead history retention</td>
                  <td className="py-4 px-6 text-center text-gray-600">30 days</td>
                  <td className="py-4 px-6 text-center text-gray-600">3 months</td>
                  <td className="py-4 px-6 text-center text-gray-600">12 months</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 text-gray-600">Team seats</td>
                  <td className="py-4 px-6 text-center text-gray-600">2</td>
                  <td className="py-4 px-6 text-center text-gray-600">5</td>
                  <td className="py-4 px-6 text-center text-gray-600">10</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 text-gray-600">Lead filtering options</td>
                  <td className="py-4 px-6 text-center text-gray-600">Basic</td>
                  <td className="py-4 px-6 text-center text-gray-600">Advanced</td>
                  <td className="py-4 px-6 text-center text-gray-600">Premium</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 text-gray-600">Video calling</td>
                  <td className="py-4 px-6 text-center">
                    <span className="inline-block text-red-500">✕</span>
                  </td>
                  <td className="py-4 px-6 text-center">
                    <Check className="inline-block h-5 w-5 text-green-500" />
                  </td>
                  <td className="py-4 px-6 text-center">
                    <Check className="inline-block h-5 w-5 text-green-500" />
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 text-gray-600">Schedule demo meetings</td>
                  <td className="py-4 px-6 text-center">
                    <span className="inline-block text-red-500">✕</span>
                  </td>
                  <td className="py-4 px-6 text-center">
                    <Check className="inline-block h-5 w-5 text-green-500" />
                  </td>
                  <td className="py-4 px-6 text-center">
                    <Check className="inline-block h-5 w-5 text-green-500" />
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 text-gray-600">Dedicated account manager</td>
                  <td className="py-4 px-6 text-center">
                    <span className="inline-block text-red-500">✕</span>
                  </td>
                  <td className="py-4 px-6 text-center">
                    <span className="inline-block text-red-500">✕</span>
                  </td>
                  <td className="py-4 px-6 text-center">
                    <Check className="inline-block h-5 w-5 text-green-500" />
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 text-gray-600">Support level</td>
                  <td className="py-4 px-6 text-center text-gray-600">Email</td>
                  <td className="py-4 px-6 text-center text-gray-600">Priority email</td>
                  <td className="py-4 px-6 text-center text-gray-600">24/7 priority</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      
      {/* FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-lg text-gray-600">
              Everything you need to know about LeadPro
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-white dark:bg-dark/50 rounded-lg p-6 shadow-sm border border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                How does LeadPro find relevant leads?
              </h3>
              <p className="text-gray-600">
                We use advanced market intelligence and intent data to identify companies actively looking for solutions like yours. We then verify their contact information and ensure they are decision-makers with budget authority.
              </p>
            </div>
            
            <div className="bg-white dark:bg-dark/50 rounded-lg p-6 shadow-sm border border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Can I upgrade or downgrade my plan?
              </h3>
              <p className="text-gray-600">
                Yes, you can upgrade or downgrade your plan at any time. When you upgrade, you'll be charged the prorated difference. Downgrading will take effect at the end of your current billing cycle.
              </p>
            </div>
            
            <div className="bg-white dark:bg-dark/50 rounded-lg p-6 shadow-sm border border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                What industries do you cover?
              </h3>
              <p className="text-gray-600">
                LeadPro covers a wide range of industries including SaaS, IT, Finance, Healthcare, Manufacturing, Retail, and more. Our platform allows you to filter leads by industry to focus on your target market.
              </p>
            </div>
            
            <div className="bg-white dark:bg-dark/50 rounded-lg p-6 shadow-sm border border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Is there a free trial available?
              </h3>
              <p className="text-gray-600">
                LeadrPro offers a FREE tier that allows you to view up to 50 leads per month.
              </p>
            </div>
            
            <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 ">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                How often are new leads added?
              </h3>
              <p className="text-gray-600">
                New leads are added to our platform daily. Depending on your industry and targeting preferences, you can expect anywhere from 10-50 new leads per week that match your criteria.
              </p>
            </div>
            
            <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 ">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                How does the video calling feature work?
              </h3>
              <p className="text-gray-600">
                Our integrated video calling feature allows you to schedule and conduct virtual meetings directly through the LeadPro platform. You can send meeting invites, share your screen, and record sessions for future reference.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-purple-700 to-purple-500 text-white">
        <div className="container-custom text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to supercharge your sales pipeline?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Join thousands of companies using LeadPro to connect with high-quality leads and close more deals.
          </p>
          {/* <Button className="bg-white text-purple-700 hover:bg-gray-100 px-8 py-6 text-lg">
            Start Your Free Trial
          </Button> */}
          <p className="mt-4 text-purple-200">
            No credit card required. Cancel anytime.
          </p>
        </div>
      </section>
      
    </div>
  );
};

export default Subscription;